import { addItemToCollection } from "directus/src/operations";

export async function createTool({ item }) {
  try {
    const data = await addItemToCollection("tools", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
